import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { projectCode, RequestsConfigModule } from '@eredes/dfcore';
import { Observable, of } from 'rxjs';

import { UserService } from '../_core/services/user.service';

import { AuthService } from './auth.service';

import { UserModel } from 'app/_core/models/user.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthRequestGuard {
  constructor(
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly authService: AuthService,
    private readonly requestsConfigModule: RequestsConfigModule
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['login']);

      return false;
    }

    const user: UserModel = this.userService.getUser();

    const getNameOfUserByUuid = (uuid: string): Observable<string> => {
      return of(user.userName);
    };

    this.requestsConfigModule.projectCode = projectCode.COMERCIALIZADORES;
    this.requestsConfigModule.userCode = user.userUniqueCode;
    this.requestsConfigModule.routeBasePath = '/request';
    this.requestsConfigModule.apiUrl = environment.apiBaseUrl;
    this.requestsConfigModule.getUserName = getNameOfUserByUuid;
    this.requestsConfigModule.defaultValues = {
      user: {
        entity: user.retailerAlias,
        name: user.userName,
        nif: null,
        email: user.userEmail,
        phone: user.userPhone,
        countyCode: null,
        parishCode: null,
        partnerNumber: user.retailerPartnerNumber,
        contractAccountNumber: null,
        roles: null,
      },
    };

    if (state.url.startsWith('/request/request-edp') && this.userService.isProfileRetailer()) {
      return this.router.parseUrl('/request/solicitation');
    }

    if (
      [
        '/request/history',
        '/request/solicitation',
        '/request/request-cpe',
        '/request/list',
        '/request/solicitation/detail',
        '/request/create',
        '/request/history',
        '/request/request-edp',
        '/request/request-edp',
      ].some((elem) => state.url.startsWith(elem))
    ) {
      return true;
    }

    const hasPermissionForHistory = route.data.expectedPermissions.history.some((expectedPermission) =>
      this.userService.getUser().userPermissions.includes(expectedPermission)
    );

    if (hasPermissionForHistory) {
      return this.router.parseUrl('/request/history');
    }
  }
}
